<template>
  <div class="wx-auth-page">
    <van-loading type="spinner" size="40px" vertical>
      微信登录中...
    </van-loading>
  </div>
</template>

<script>
import { getUrlParam } from "@/utils/wxAuth";
import { GetWxUserInfo, LoginWechat } from "../api/mallapi.js";

export default {
  name: "WxAuth",
  data() {
    return {
      hasProcessed: false,
    };
  },
  async mounted() {
    await this.handleWeChatAuth();
  },
  methods: {
    async handleWeChatAuth() {
      // 防止重复处理
      if (this.hasProcessed) return;
      this.hasProcessed = true;

      // 显示加载提示
      this.$toast.loading({
        message: "登录中...",
        forbidClick: true,
        duration: 0,
      });

      // 获取URL中的code参数
      let code = this.$route.query.code || getUrlParam("code");

      if (!code) {
        this.$toast.clear();
        this.$toast.fail("获取授权码失败，请重新登录");
        setTimeout(() => {
          this.$router.replace("/login");
        }, 1500);
        return;
      }

      var wechatInfo = await this._getWxUserInfo(code);
      this._loginWechat(wechatInfo).then((res) => {
        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            accountId: res.fullInfo.accountInfo.accountId,
            logonId: res.guid,
            account_no: res.fullInfo.accountInfo.number,
            loginType: 1,
          })
        );

        this.$router.replace({
          name: "Mall",
        });
      });
    },

    //微信授权获取用户信息
    _getWxUserInfo(code) {
      var par = {
        code: code,
      };
      return GetWxUserInfo(par);
    },

    //微信登录
    _loginWechat(wechatInfo) {
      var par = {
        UnionId: wechatInfo.unionid,
        Sex: wechatInfo.sex,
        HeadImgUrl: wechatInfo.headimgurl,
        Nickname: wechatInfo.nickname,
        OpenId: wechatInfo.openid,
      };
      return LoginWechat(par);
    },
  },
};
</script>

<style scoped>
.wx-auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}
</style>